module.exports = __webpack_public_path__ + "static/media/TermsOfUse.690010e4.pdf";